var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"facebookPhotos"},_vm._l((_vm.facebookPhotos),function(photo){return _c('img',{key:photo.thumb,attrs:{"src":photo.thumb},on:{"click":function($event){return _vm.$emit('input', photo.full)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }